import { CanDeactivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfimationModalComponent } from "../confimation-modal/confimation-modal.component";
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SharedService } from './shared.service';



export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
  dialog: MatDialog;
}

@Injectable()
export class FormErrorsGuard implements CanDeactivate<ComponentCanDeactivate> {
  
  constructor(
    private dialog: MatDialog,
    private sharedService: SharedService
  ){

  }
 async canDeactivate(component: ComponentCanDeactivate) {
    // if there are no pending changes, just allow deactivation; else confirm first
    return component.canDeactivate() ?
      true :
      // NOTE: this warning message will only be shown when navigating elsewhere within your angular app;
      // when navigating away from your angular app, the browser will show a generic warning message
      // see http://stackoverflow.com/a/42207299/7307355
      await this.openConfirmDialog()
  }

  async openConfirmDialog() {
    const dialogRef = this.dialog.open(ConfimationModalComponent, {
			width: '500px',
			autoFocus  : false,
			data : {
				title : 'Confirm your action',
        body: "Due to errors we won't be able to save the changes. Do you want to continue?"
			}
		})
    return dialogRef.afterClosed().toPromise().then((result) => {
      return Promise.resolve(result)
    })
  }
}